module.exports = __webpack_public_path__ + "img/Eva-Parrish.bffe2e74.jpg";